<div class="card-body">
  <div class="row">
    <div class="col-md-12">
      <section class="example-full-width" *ngFor="let projectPermission of projectPermissions">
        <a>
          <mat-slide-toggle color="primary" [(ngModel)]="projectPermission.permissionValue" (change)="onChange()"
          >{{projectPermission.displayName}}</mat-slide-toggle>
        </a>
        <a>
          <mat-icon
          matTooltip="{{projectPermission.description}}"
          matTooltipPosition="right"
          style="cursor: pointer; color: #303f6f;">
          info
          </mat-icon>
        </a>
      </section>
    </div>
  </div>
</div>